import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../../../../redux/hooks";
import { CustomDetailsList } from "../../../../../common/customDetailsList/customDetailsList";
import { Skeleton } from "../../../../../common/skeleton/skeleton";
import { MasterBlockMasterController } from "../controller/controller";
import { MasterBlocksColumns } from "./column/column";
import { SkeletonSizes } from "../../../../../../common/enum/sizes";
import { fetchMasterBlocksList } from "../../../../../../redux/actions/resources/master/block/block";

interface IMasterBlockListContainerProps {
    widthPopUp: any;
    heigthPopUp: any;
}

export const MasterBlockListContainer: React.FC<IMasterBlockListContainerProps> = ({ heigthPopUp, widthPopUp }) => {
    const { list, loading } = useAppSelector((state) => state.masterBlockList);
    const dispatch = useAppDispatch();
    const renderColumns = () => {
        return MasterBlocksColumns();
    };
    useEffect(() => {
        list === undefined && !loading && dispatch(fetchMasterBlocksList());
    }, [list]);
    return (
        <div style={{ height: "100%" }}>
            {loading ? (
                <Skeleton rows={SkeletonSizes.DEFAULT} />
            ) : (
                <CustomDetailsList
                    data={list ?? []}
                    renderColumns={renderColumns}
                    height={"calc(100vh - 10rem)"}
                />
            )}
            <MasterBlockMasterController
                widthPopUp={widthPopUp}
                heigthPopUp={heigthPopUp}
            />
        </div>
    );
};
